import axios from 'axios'

const urlManufacturings = process.env.VUE_APP_NODE_ENV === 'production'
  ? `${process.env.VUE_APP_API_PROD}/manufacturings` : `${process.env.VUE_APP_API_DEV}/manufacturings`

export default {
  namespaced: true,
  state: {
    manufacturingsList: null,
  },
  getters: {},
  mutations: {
    HYDRATE_MANUFACTURINGSLIST(state, data) {
      state.manufacturingsList = data
    },
  },
  actions: {
    findManufacturing(state, manufacId) {
      axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      axios.defaults.headers.post['Content-Type'] = 'application/json'
      return new Promise((resolve, reject) => {
        axios
          .get(`${urlManufacturings}/${manufacId}`)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    findManufacturingByDevice(state, deviceName) {
      axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      axios.defaults.headers.post['Content-Type'] = 'application/json'
      return new Promise((resolve, reject) => {
        axios
          .get(`${urlManufacturings}?device_serialnumber=${deviceName}`)
          .then(response => {
            resolve(response.data[0])
          })
          .catch(error => reject(error))
      })
    },
    findAllManufacturings(state) {
      axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      axios.defaults.headers.post['Content-Type'] = 'application/json'
      return new Promise((resolve, reject) => {
        axios
          .get(`${urlManufacturings}`)
          .then(response => {
            state.commit('HYDRATE_MANUFACTURINGSLIST', response.data)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    createManufacturing(state, body) {
      axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      axios.defaults.headers.post['Content-Type'] = 'application/json'
      return new Promise((resolve, reject) => {
        axios
          .post(`${urlManufacturings}`, body)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    updateManufacturing(state, { manufacId, body }) {
      axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      axios.defaults.headers.post['Content-Type'] = 'application/json'
      return new Promise((resolve, reject) => {
        axios
          .patch(`${urlManufacturings}/${manufacId}`, body)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    deleteManufacturing(state, manufacId) {
      axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      axios.defaults.headers.post['Content-Type'] = 'application/json'
      return new Promise((resolve, reject) => {
        axios
          .delete(`${urlManufacturings}/${manufacId}`)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
